module.exports = __webpack_public_path__ + "img/subscription.4527b9e5.svg";